import type {} from "@nv-ces/ucp-wrapper";

export interface UcpBaseOptions {
  environment: EnvironmentAPI;
  theme: Theme;
  nonce: string;
  locale: string;
  currency: string;
  clientFlavor: string;
  version: string;
  clientId: string;
  enableDeviceFingerprint: boolean;
}

interface BuildUcpOptionsInput {
  base: UcpBaseOptions;
  isGuest: boolean;
  guestToken?: string | null;
  registeredToken?: string | null;
  ncaId?: string;
}

export const getUcpEnvironment = (): EnvironmentAPI => {
  const hostPrefix = window.location.hostname.split("-")[0]?.toUpperCase();
  if (hostPrefix === "DEV") {
    return "DEV_UE1" as EnvironmentAPI;
  }
  return (hostPrefix === "STG" ? "STG" : "PROD") as EnvironmentAPI;
};

export const buildUcpOptions = ({
  base,
  isGuest,
  guestToken,
  registeredToken,
  ncaId,
}: BuildUcpOptionsInput): UcpWrapperOptions => {
  if (isGuest) {
    return {
      ...base,
      ...(guestToken ? { token: guestToken } : {}),
    } as UcpWrapperOptions;
  }

  return {
    ...base,
    ...(registeredToken
      ? { token: registeredToken, ...(ncaId ? { ncaId } : {}) }
      : {}),
  } as UcpWrapperOptions;
};
